export class ConfigurationCode {
  readonly configurationCodeSuffix: string;
  readonly projectCode: string;

  constructor(configurationCodeSuffix: string, projectCode: string) {
    this.configurationCodeSuffix = configurationCodeSuffix;
    this.projectCode = projectCode;
  }

  toString(): string {
    return `${this.projectCode}.${this.configurationCodeSuffix}`;
  }

  static from(codeString: string): ConfigurationCode | null {
    const [projectCode, codeSuffix] = codeString.split('.');
    return projectCode && codeSuffix ? new ConfigurationCode(codeSuffix, projectCode) : null;
  }
}
